exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-panel[data-v-4165094c]{padding:5rem 0;background-color:#e9ecef}.contact-panel .content[data-v-4165094c]{margin:0 auto;max-width:60rem}.contact-panel .contact-form[data-v-4165094c]{min-height:17.5rem;padding:0 2rem}.contact-panel .contact-form .alert[data-v-4165094c]{cursor:pointer}.contact-panel .component-fade-enter-active[data-v-4165094c],.contact-panel .component-fade-leave-active[data-v-4165094c]{-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.contact-panel .component-fade-enter[data-v-4165094c],.contact-panel .component-fade-leave-to[data-v-4165094c]{opacity:0}", ""]);

// exports
